(function () {
  function init() {
    document.querySelectorAll('.pb-gal__th').forEach(function (row) {
      if (row.dataset.pbDrag) return; row.dataset.pbDrag = 1;
      var down = false, moved = false, sx = 0, sl = 0;
      row.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; moved = false; sx = e.clientX; sl = row.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 4) moved = true;
        row.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () { down = false; });
      row.addEventListener('click', function (e) { if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; } }, true);
      row.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) < Math.abs(e.deltaY) || row.scrollWidth <= row.clientWidth) return;
        e.preventDefault(); row.scrollLeft += e.deltaX;
      }, { passive: false });
      row.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pb-thumb]'); if (!b) return;
        var l = b.offsetLeft - (row.clientWidth - b.offsetWidth) / 2;
        row.scrollTo({ left: l, behavior: 'smooth' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
